function downloadCsv(data, fileName) {
  const blob = new global.Blob(["\ufeff", data], {
    type: "text/csv"
  });
  const src = global.window.URL.createObjectURL(blob);
  const element = global.document.createElement("a");

  element.href = src;
  element.download = fileName;
  element.click();
}

export { downloadCsv };
